import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LngDetector from 'i18next-browser-languagedetector';

import resources from './locales/index';
import { languageCodes, resolveLanguageCode } from './utils/languageCatalog';

class ResolvingLanguageDetector {
  constructor(services, options) {
    this.type = 'languageDetector';
    this.inner = new LngDetector(services, options);
  }

  init(services, detectorOptions, i18nOptions) {
    this.inner.init(services, detectorOptions, i18nOptions);
  }

  detect(detectionOrder) {
    const order = detectionOrder || this.inner.options.order;

    if (order.includes('querystring')) {
      const fromQuery = this.inner.detectors.querystring.lookup(this.inner.options);
      const tag = Array.isArray(fromQuery) ? fromQuery[0] : fromQuery;
      if (tag) {
        return resolveLanguageCode(tag);
      }
    }

    if (order.includes('navigator')) {
      const fromNavigator = this.inner.detectors.navigator.lookup(this.inner.options);
      if (fromNavigator) {
        return resolveLanguageCode(fromNavigator);
      }
    }

    return undefined;
  }

  cacheUserLanguage(lng, caches) {
    this.inner.cacheUserLanguage(lng, caches);
  }
}

ResolvingLanguageDetector.type = 'languageDetector';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(ResolvingLanguageDetector)
  .init({
    resources,
    detection: {
      order: ['querystring', 'navigator'],
    },
    lowerCaseLng: true,
    supportedLngs: [...languageCodes],
    nonExplicitSupportedLngs: false,
    fallbackLng: 'en',
    load: 'currentOnly',
    debug: process.env.NODE_ENV !== 'production',
    ns: ['common'],
    defaultNS: 'common',

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
